<template>
<div>
    <div class="row p-2">
      <div class="col-12 underline d-flex align-items-center justify-content-between">
        <div class="searchTitle">{{$ml.get('ACTIVITIES')}}</div>
        <!-- <a href="https://www.minimumcrm.com/raporlar-satis-analizi#aktivite-tab" target="_blank" class="btn btn-primary text-white px-3 font-weight-bold mb-2 btnHelp"><span class="fas fa-exclamation-circle pr-2"></span>{{$ml.get('HELP')}}</a> -->
      </div>
      <hr>
    </div>
  <div class="row pt-4">
      <div class="col-12">
           <div class="row w-100 pl-3">
            <div class="col-12 col-xl-6 hpx-100">
                <div v-show="userId=='all'">
                    <div class="activityFilterMenu px-2">
                        <button type="button" :class="{active:setId == 0}" @click="setId=0" class="btn ">{{$ml.get('ALL')}}</button>
                        <button type="button" :class="{active:setId == 1}" @click="setId=1" class="btn ">{{$ml.get('CALL')}}</button>
                        <button type="button" :class="{active:setId == 3}" @click="setId=3" class="btn ">{{$ml.get('TASK')}}</button>
                        <button type="button" :class="{active:setId == 2}" @click="setId=2" class="btn ">{{$ml.get('APPOINTMENT')}}</button>
                        <button type="button" :class="{active:setId == 4}" @click="setId=4" class="btn ">{{$ml.get('E_MAIL')}}</button>
                    </div>    
                    <div class="activityFilterMenu p-2" v-show="setId>0">
                        <button type="button" :class="{active:subSetId == 0}" @click="subSetId=0" class="btn ">{{$ml.get('ALL')}}</button>
                        <button type="button" :class="{active:subSetId == 1}" @click="subSetId=1" class="btn ">{{$ml.get('OPEN_ACTIVITY')}}</button>
                        <button type="button" :class="{active:subSetId == 2}" @click="subSetId=2" class="btn ">{{$ml.get('CLOSED_ACTIVITY')}}</button>
                    </div>     
                </div>            
            </div>
            <div class="col-12 col-lg-6 text-right filter" id="userSelect">
                <div class="activityFilterMenu align-self-center">
                    <span class="text-center f-14 font-family-bold font-weight-normal m-0">{{formatDate(showDate.beginDate, "DD-MM-YYYY")}} - {{formatDate(showDate.endDate, "DD-MM-YYYY")}}</span>
                    <button  v-if="!clickSelectUser && $can('can_see_other_users_activities_report')" type="button" @click="clickSelectUser=true" class="btn f-14 asap-normal f-w-normal pl-3 pr-3 light-blue-border w-auto selectUser">{{$ml.get('SELECT_USER')}}</button>
                    <button type="button" :class="{active:setDate == 'selectDateButton'}" @click="setDate='selectDateButton'" class="btn f-14 asap-normal f-w-normal pl-3 pr-3 light-blue-border w-auto">{{$ml.get('SELECT_DATE')}}</button>
                </div>
            </div>
            <div class="row col-12 float-right justify-content-end py-2" style="display:flex;" v-show="setDate=='selectDateButton'">
                <div class="selectArea  d-flex mr-2">
                    <div class="first">
                        <v-select :options="dateTypeList" :reduce="name => name.value" v-model="dateTypeSelector" label="name" :searchable="false"/>
                    </div>
                    <div class="last searchInput">
                        <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" class="new-ctk" id="activityreport" :label="$ml.get('SELECT_DATE')" v-model="selectDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="true" :onlyDate="true" :custom-shortcuts="dateShortcuts" :auto-close="true"></vue-ctk-date-time-picker>
                    </div>
                </div>
                <button type="button" @click="setDate='selectDate',changeDate()" class="btn btn-sm f-14 asap-normal mr-2 f-w-normal light-blue-border w-auto dateOkeyButton">{{$ml.get('COMPLETE')}}</button>
                <button type="button" @click="setDate=undefined,changeDate()" class="btn btn-sm f-14 asap-normal f-w-normal light-blue-border w-auto dateCancelButton">{{$ml.get('CANCEL')}}</button>
            </div>
            <div class="row col-12 py-2" v-if="clickSelectUser">
                <div class="v-h-right w-100">
                    <select v-model="userId" class="form-control input-padding border-radius-20 f-14 light-blue-border h-36 font-family-bold w-auto mr-2">
                        <option value="all">Tüm Kullanıcılar</option>
                        <option :value="u._id.$oid" :selected="u._id.$oid==user._id.$oid" :key="index" v-for="(u,index) in users">{{u.name}} {{u.surName}}</option>
                    </select>
                    <button type="button" @click="userId='all',clickSelectUser=undefined" class="btn btn-sm f-14 asap-normal f-w-normal light-blue-border w-auto dateCancelButton">{{$ml.get('CANCEL')}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 pl-5 pr-5" v-show="setId==0">
        <div class="row mt-4 mb-4 " style="align-self: center;">
               <div class="col-12 col-lg-6 ">
                    <div class="align-self-center">
                        <report-chart :data="pieData" :color="pieColor" />
                    </div>
                    <div class="align-self-center p-4">
                        <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('ACTIVITY_AMMOUNT_PERCENTAGE_CHART')}}</p> 
                    </div>
               </div>
               <div class="col-12 col-lg-6" style="align-self: center;">
                    <div class="col-12 col-lg-6 float-left">
                        <div class="card border-success">
                            <div class="card-header bg-success">
                                {{$ml.get('CALL')}}
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('OPEN')}}</span>  <span class="float-right">{{info.call.open}}</span></li>
                                <li class="list-group-item bg-light-success"><span class="float-left">{{$ml.get('CLOSED')}}</span>  <span class="float-right">{{info.call.close}}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 float-left">
                        <div class="card border-danger">
                            <div class="card-header bg-danger">
                                {{$ml.get('TASK')}}
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('OPEN')}}</span>  <span class="float-right">{{info.task.open}}</span></li>
                                <li class="list-group-item bg-light-danger"><span class="float-left">{{$ml.get('CLOSED')}}</span>  <span class="float-right">{{info.task.close}}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 float-left mt-3">
                        <div class="card border-warning">
                            <div class="card-header bg-warning">
                                {{$ml.get('APPOINTMENT')}}
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('OPEN')}}</span>  <span class="float-right">{{info.meeting.open}}</span></li>
                                <li class="list-group-item bg-light-warning"><span class="float-left">{{$ml.get('CLOSED')}}</span>  <span class="float-right">{{info.meeting.close}}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 float-left mt-3">
                        <div class="card border-primary">
                            <div class="card-header bg-primary">
                                {{$ml.get('E_MAIL')}}
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item bg-light-primary"><span class="float-left">{{$ml.get('OPEN')}}</span>  <span class="float-right">{{info.email.open}}</span></li>
                                <li class="list-group-item bg-light-primary"><span class="float-left">{{$ml.get('CLOSED')}}</span>  <span class="float-right">{{info.email.close}}</span></li>
                            </ul>
                        </div>
                    </div>
               </div>                
        </div>
    </div>
    <div class="col-12 pl-5 pr-5" v-show="setId>0 && subSetId==0">
        <div class="row mt-4 mb-4 border " style="align-self: center;">
            <div class="col-12 col-lg-3  pt-3" :class="{'light-grey-border':greyActive,'light-blue-border':blueActive,'light-green-border':greenActive,'light-red-border':redActive,'light-yellow-border':yellowActive}">
                <div class="card" :class="{'border-warning':setId==1,'border-success':setId==2,'border-danger':setId==3,'border-primary':setId==4}">
                    <div class="card-header" :class="{'bg-warning':setId==1,'bg-success':setId==2,'bg-danger':setId==3,'bg-primary':setId==4}">
                        <span>{{setTitle}}</span>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item " :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3,'bg-light-primary':setId==4}">
                            <span class="float-left">{{$ml.get('OPEN')}}</span> 
                            <span class="float-right" v-if="setId==1">{{info.call.open}}</span>
                            <span class="float-right" v-if="setId==3">{{info.task.open}}</span>
                            <span class="float-right" v-if="setId==2">{{info.meeting.open}}</span>
                            <span class="float-right" v-if="setId==4">{{info.email.open}}</span>
                        </li>
                        <li class="list-group-item " :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3,'bg-light-primary':setId==4}">
                            <span class="float-left">{{$ml.get('CLOSED')}}</span> 
                            <span class="float-right" v-if="setId==1">{{info.call.close}}</span>
                            <span class="float-right" v-if="setId==3">{{info.task.close}}</span>
                            <span class="float-right" v-if="setId==2">{{info.meeting.close}}</span>
                            <span class="float-right" v-if="setId==4">{{info.email.close}}</span>
                        </li>
                    </ul>
                </div>
            </div> 
            <div class="col-12 col-lg-9">
                <div class="align-self-center">
                    <bar-chart :data="barChartData" class="mt-3" :color="pieColor" :options="barChartOptions" :labels="barChartLabels"></bar-chart>
                </div>
                <div class="align-self-center p-4">
                    <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('ACTIVITY_PER_USER_CHART')}}</p> 
                </div>
            </div>           
        </div>
    </div>
    <div class="col-12 pl-5 pr-5" v-show="setId!=0 && subSetId>0">
        <div class="row mt-4 mb-4 border " style="align-self: center;">
            <div class="col-12 col-lg-3 pt-3" :class="{'light-grey-border':greyActive,'light-blue-border':blueActive,'light-green-border':greenActive,'light-red-border':redActive,'light-yellow-border':yellowActive}">
                <div class="card" :class="{'border-warning':setId==1,'border-success':setId==2,'border-danger':setId==3,'border-primary':setId==4}">
                    <div class="card-header" :class="{'bg-warning':setId==1,'bg-success':setId==2,'bg-danger':setId==3,'bg-primary':setId==4}">
                        <span>{{setTitle}}</span>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item " v-if="subSetId==1" :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3,'bg-light-primary':setId==4}">
                            <span class="float-left">{{$ml.get('OPEN')}}</span> 
                            <span class="float-right" v-if="setId==1">{{info.call.open}}</span>
                            <span class="float-right" v-if="setId==3">{{info.task.open}}</span>
                            <span class="float-right" v-if="setId==2">{{info.meeting.open}}</span>
                            <span class="float-right" v-if="setId==4">{{info.email.open}}</span>
                        </li>
                        <li class="list-group-item "  v-if="subSetId==2" :class="{'bg-light-warning':setId==1,'bg-light-success':setId==2,'bg-light-danger':setId==3,'bg-light-primary':setId==4}">
                            <span class="float-left">{{$ml.get('CLOSED')}}</span> 
                            <span class="float-right" v-if="setId==1">{{info.call.close}}</span>
                            <span class="float-right" v-if="setId==3">{{info.task.close}}</span>
                            <span class="float-right" v-if="setId==2">{{info.meeting.close}}</span>
                            <span class="float-right" v-if="setId==4">{{info.email.close}}</span>
                        </li>
                    </ul>
                </div>
            </div> 
            <div class="col-12 col-lg-9">
                <div class="align-self-center">
                    <bar-chart :data="barChartData" class="mt-3" :color="pieColor" :options="barChartOptions" :labels="barChartLabels"></bar-chart>
                </div>
                <div class="align-self-center p-4">
                    <p class="text-center f-15 font-family-bold font-weight-normal m-0">{{$ml.get('ACTIVITY_PER_USER_CHART')}}</p> 
                </div>
            </div>           
        </div>
    </div>
</div>
    
    <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import BarChart from '../charts/HorizontalBarChart.js'
import PieChart from './PieChart.vue'
export default {
    data () {
        return {
            pieData:[],
            pieColor:[],
            barChartLabels:[],
            barChartData:[
                {
                    label: "ADET",
                    backgroundColor: [],
                    data: []
                },
            ],
            barChartOptions: {
                height:400,
                legend: { display: true },
                responsive: false,
                scales: {
                    xAxes: [{
                        ticks: {
                        maxRotation: 90,
                        minRotation: 80
                        }
                    }],
                    yAxes: [{
                        ticks: {
                        beginAtZero: true
                        }
                    }]
                }
            },
            setDate:undefined,
            setId:0,
            subSetId:0,
            setTitle:undefined,
            selectDate:undefined,
            blueActive:false,
            greenActive:false,
            redActive:false,
            yellowActive:false,
            greyActive:false,
            clickSelectUser:undefined,
            activityReports:[],
            info:{
                call:{
                    close:0,
                    open:0
                },
                meeting:{
                    close:0,
                    open:0
                },
                task:{
                    close:0,
                    open:0
                },
                email:{
                    close:0,
                    open:0
                }
            },
            oldDateVal:undefined,
            newDateVal:undefined,
            userId:'all',
            showDate:{},
            dateTypeSelector:'dueDate',
            dateTypeList:[
                {value:"dueDate",name:this.$ml.get('PLANNING_HISTORY')},
                {value:"addDate",name:this.$ml.get('CREATION_DATE')},
                {value:"doneDate",name:this.$ml.get('CLOSING_DATE')},
            ],
            dateShortcuts:[
                { key: 'thisQuarter', label: this.$ml.get('THIS_QUARTER'), value: 'quarter' },//
                { key: 'thisMonth', label: this.$ml.get('THIS_MONTH'), value: 'month' },//
                { key: 'lastMonth', label: this.$ml.get('LAST_MONTH'), value: '-month' },//
                { key: 'thisWeek', label: this.$ml.get('THIS_WEEK'), value: 'isoWeek' },//
                { key: 'lastWeek', label: this.$ml.get('LAST_WEEK'), value: '-isoWeek' },//
                { key: 'thisYear', label: this.$ml.get('THIS_YEAR'), value: 'year' },//
                { key: 'lastYear', label: this.$ml.get('LAST_YEAR'), value: '-year' }//
            ]
        }
    },
    props:["user","users","permissions","activeTab"],
    components:{
        BarChart,
        "report-chart":PieChart,
    },
    computed:{
        ...mapState([
            'baseUrl',
            'reports',
            'reportLoading'
        ]),
        ...mapGetters(['localeLang'])
    },
    methods:{
        formatDate(value, format) {
            return this.$moment(value).format(format);
        },
        totalRounded(value){
            if(value !== undefined && value !== null){
                value = Math.round(value*100)/100
                return value
            }
            return 0
        },
        ...mapActions([
            'updateLoading',
            'getReport'
        ]),
        clear(){
            this.pieData=[],
            this.pieColor=[],
            this.info={
                call:{
                    close:0,
                    open:0
                },
                meeting:{
                    close:0,
                    open:0
                },
                task:{
                    close:0,
                    open:0
                },
                email:{
                    close:0,
                    open:0
                }
            }
            this.greyActive=true
            this.redActive=false
            this.blueActive=false
            this.greenActive=false
            this.yellowActive=false
        },
        getReports(field){
            this.clear()
            let obj =this.dateFormat(field)
            if(this.$can("can_see_other_users_activities_report")){
                if(this.userId!=undefined && this.userId!="all"){
                    obj["userId"]=this.userId
                }else{
                    delete obj["userId"]
                }
            }else{
                if(this.user._id!=undefined){
                    //obj["userId"]=this.user._id.$oid
                }else{
                    return false
                }
                
            }
             
            if(this.activeTab=="activity"){
                this.getReport(obj)
            }
            
        },
        createdChart(){
            this.info={
                call:{
                    close:0,
                    open:0
                },
                meeting:{
                    close:0,
                    open:0
                },
                task:{
                    close:0,
                    open:0
                },
                email:{
                    close:0,
                    open:0
                }
            }

            this.activityReports=[]
            let array =[]
            let labelArray=[]
            this.pieColor=[]
            this.pieData=[]
            if( this.reports.activities!=undefined){
                this.reports.activities.forEach(element => {
                    if(element.type==1){
                        if(element.done){
                            if(element.count!=undefined){
                                this.info.call["close"]+=element.count
                            }
                        }else{
                            if(element.count!=undefined){
                                this.info.call["open"]+=element.count
                            }else{
                                this.info.call["open"]=0
                            }
                        }

                        if(this.info.call.open!=undefined && this.info.call.close!=undefined){
                            array[0]=this.info.call.open 
                            array[1]=this.info.call.close
                            labelArray[0]=this.$ml.get('OPEN_CALL')
                            labelArray[1]=this.$ml.get('CLOSED_CALL')
                        }
                    }
                    if(element.type==2){
                        if(element.done){
                            if(element.count!=undefined){
                                this.info.meeting["close"]+=element.count
                            }
                        }else{
                            if(element.count!=undefined){
                                this.info.meeting["open"]+=element.count
                            }else{
                                this.info.meeting["open"]=0
                            }
                        }

                        if(this.info.meeting.open!=undefined && this.info.meeting.close!=undefined){
                            array[4]=this.info.meeting.open
                            array[5]=this.info.meeting.close
                            labelArray[4]=this.$ml.get('OPEN_APPOUNTMENT')
                            labelArray[5]=this.$ml.get('CLOSED_APPUNTMENT')
                        }
                    }
                    if(element.type==3){
                        if(element.done){
                            if(element.count!=undefined){
                                this.info.task["close"]+=element.count
                            }
                        }else{
                            if(element.count!=undefined){
                                this.info.task["open"]+=element.count
                            }else{
                                this.info.task["open"]=0
                            }
                        }
                        if(this.info.task.open!=undefined && this.info.task.close!=undefined){
                            array[2]=this.info.task.open
                            array[3]=this.info.task.close
                            labelArray[2]=this.$ml.get('OPEN_TASK')
                            labelArray[3]=this.$ml.get('CLOSED_TASK')
                        }
                    }
                    if(element.type==4){
                        if(element.done){
                            if(element.count!=undefined){
                                this.info.email["close"]+=element.count
                            }
                        }else{
                            if(element.count!=undefined){
                                this.info.email["open"]+=element.count
                            }else{
                                this.info.email["open"]=0
                            }
                        }

                        if(this.info.email.open!=undefined && this.info.email.close!=undefined){
                            array[6]=this.info.email.open
                            array[7]=this.info.email.close
                            labelArray[6]=this.$ml.get('OPEN_EMAIL')
                            labelArray[7]=this.$ml.get('CLOSED_EMAIL')
                        }
                    }
                    
                });
                let color =['#0C59B2','#003644','#B50006','#620601','#FFCC00','#C19909','#789A29','#2A4705']
                array.forEach((element,index) => {
                    let obj={}
                    obj["name"]=labelArray[index]
                    obj["value"]=array[index]
                    this.pieData.push(obj)
                    this.pieColor.push(color[index])
                });
            }
        },
        dateFormat(format){
            this.showDate['dateField']=this.dateTypeSelector
            if(format=='today'){
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-DD")
                let end = this.$moment().format("YYYY-MM-DD")
                this.showDate["beginDate"]=start
                this.showDate["endDate"]=end
                return this.showDate
            }else if(format=='tomorrow'){
                this.selectDate=undefined
                let start=this.$moment(new Date()).add(1,'days').format("YYYY-MM-DD");
                let end = this.$moment(new Date()).add(1,'days').format("YYYY-MM-DD");
                this.showDate["beginDate"]=start
                this.showDate["endDate"]=end

                return this.showDate
            }else if(format=='mounth'){
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-01")
                let end = this.$moment().format("YYYY-MM-DD")
                this.showDate["beginDate"]=start
                this.showDate["endDate"]=end
                return this.showDate
            }else if(format=='selectDate'){
                if(this.selectDate.start!=undefined && this.selectDate.start!=null && this.selectDate.end!=undefined && this.selectDate.end!=null){
                    this.showDate["beginDate"]=this.selectDate.start
                    this.showDate["endDate"]=this.selectDate.end
                    this.setDate="selectDateButton"
                    return this.showDate
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warn', 
                        title:this.$ml.get('DATE_CANNOT_BE_BLANK'),
                        text: this.$ml.get('PLEASE_SELECT_THE_DATE_RANGE')
                    })
                }
            }
            else{
                //Default mounth
                this.selectDate=undefined
                let start=this.$moment().format("YYYY-MM-01")
                let end = this.$moment().format("YYYY-MM-DD")
                this.showDate["beginDate"]=start
                this.showDate["endDate"]=end
                return this.showDate
            }
        },
        changeDate(){
            if(this.setDate==this.oldDateVal){
                this.setDate=undefined
            }
            this.getReports(this.setDate)
        },
        changeChart(){
            this.barChartLabels=[]
            this.barChartData=[]
            if( this.reports.deals!=undefined){
                if(this.setId==0){
                    this.createdChart()
                    this.setTitle=undefined
                }else{
                    this.dealReports=[]
                    let count=0
                    let personCount=0
                    let openArray =[]
                    let closeArray =[]
                    let openColor =[]
                    let closeColor =[]
                    let chartValueTotal=[]
                    let dataObj={
                        data:[],
                        backgroundColor:[]
                    }
                    if(this.reports.agents){
                        this.reports.agents.forEach(element => {
                            if(element.activities!=undefined && element.activities.length>0){
                                let open =0
                                let close=0
                                element.activities.forEach(activity => {
                                    if(this.setId!=0){
                                        if(activity.type==this.setId){

                                            if(activity.done){
                                                this.setTitle=" "
                                                close=activity.count
                                            }else{
                                                this.setTitle=" "
                                                open+=activity.count
                                            }
                                        }
                                    } 
                                })
                                if(this.subSetId==2){
                                    if(close>0){
                                        this.barChartLabels[count]=element.agent
                                        dataObj["data"][count]=close
                                        this.barChartData[0]=dataObj
                                        count++ 
                                    }
                                }else if(this.subSetId==1){
                                    if(open>0){
                                        this.barChartLabels[count]=element.agent
                                        dataObj["data"][count]=open
                                        this.barChartData[0]=dataObj
                                        count++ 
                                    }
                                }else{
                                    if(open!=0 || close!=0){
                                        this.barChartLabels[personCount]=element.agent
                                    
                                        openArray.push(open) 
                                        closeArray.push(close) 

                                        openColor.push('#' + (function co(lor){   return (lor +=[0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])&& (lor.length == 6) ?  lor : co(lor); })(''))
                                        closeColor.push('#' + (function co(lor){   return (lor +=[0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])&& (lor.length == 6) ?  lor : co(lor); })(''))
                                        
                                        let obj={}
                                        obj["label"]=this.$ml.get('OPEN_QUANTITY')
                                        obj["backgroundColor"]=openColor
                                        obj["data"]=openArray

                                        let obj2={}
                                        obj2["label"]=this.$ml.get('CLOSED_QUANTITY')
                                        obj2["backgroundColor"]=closeColor
                                        obj2["data"]=closeArray

                                        chartValueTotal[0]=obj
                                        chartValueTotal[1]=obj2

                                        this.barChartData=chartValueTotal
                                        personCount++
                                    }
                                }
                            }
                        })
                    }else{
                        
                        if(this.reports.activities!=undefined && this.reports.activities.length>0){
                            let open =0
                            let close=0
                            this.reports.activities.forEach(activity => {
                                if(this.setId!=0){
                                    if(activity.type==this.setId){

                                        if(activity.done){
                                            this.setTitle=" "
                                            close=activity.count
                                        }else{
                                            this.setTitle=" "
                                            open+=activity.count
                                        }
                                    }
                                } 
                            })
                            if(this.subSetId==2){
                                if(close>0){
                                    this.barChartLabels[count]=this.user.name
                                    dataObj["data"][count]=close
                                    this.barChartData[0]=dataObj
                                    count++ 
                                }
                            }else if(this.subSetId==1){
                                if(open>0){
                                    this.barChartLabels[count]=this.user.name
                                    dataObj["data"][count]=open
                                    this.barChartData[0]=dataObj
                                    count++ 
                                }
                            }else{
                                if(open!=0 || close!=0){
                                    this.barChartLabels[personCount]=this.user.name
                                
                                    openArray.push(open) 
                                    closeArray.push(close) 

                                    openColor.push('#' + (function co(lor){   return (lor +=[0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])&& (lor.length == 6) ?  lor : co(lor); })(''))
                                    closeColor.push('#' + (function co(lor){   return (lor +=[0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])&& (lor.length == 6) ?  lor : co(lor); })(''))
                                    
                                    let obj={}
                                    obj["label"]=this.$ml.get('OPEN_QUANTITY')
                                    obj["backgroundColor"]=openColor
                                    obj["data"]=openArray

                                    let obj2={}
                                    obj2["label"]=this.$ml.get('CLOSED_QUANTITY')
                                    obj2["backgroundColor"]=closeColor
                                    obj2["data"]=closeArray

                                    chartValueTotal[0]=obj
                                    chartValueTotal[1]=obj2

                                    this.barChartData=chartValueTotal
                                    personCount++
                                }
                            }
                        }
                        
                    }
                    
                    if(this.subSetId!=0){
                        for (let index = 0; index < count; index++) {
                            dataObj["backgroundColor"].push(
                                '#' + (function co(lor){   return (lor +=
                                [0,1,2,3,4,5,6,7,8,9,'a','b','c','d','e','f'][Math.floor(Math.random()*16)])
                                && (lor.length == 6) ?  lor : co(lor); })(''));
                        }
                        this.barChartData[0]=dataObj
                    }
                    this.reports.activities.forEach(element => {
                        this.setTitle=" "
                    });
                    this.pieData=this.dealReports
                }
            }
            if(this.setId==1){
                this.greenActive=true
                this.redActive=false
                this.yellowActive=false
                this.blueActive=false
                this.greyActive=false
            }else if(this.setId==2){
                this.blueActive=false
                this.greenActive=false
                this.redActive=true
                this.yellowActive=false
                this.greyActive=false
            }else if(this.setId==3){
                this.blueActive=false
                this.greenActive=false
                this.redActive=false
                this.greyActive=false
                this.yellowActive=true
            }else if(this.setId==4){
                this.blueActive=true
                this.greenActive=false
                this.redActive=false
                this.yellowActive=false
                this.greyActive=false
            }else{
                this.blueActive=false
                this.greyActive=true
                this.greenActive=false
                this.redActive=false
                this.yellowActive=false
            }
        }
    },
    created(){
        this.selectDate=this.$moment().format("YYYY-MM-DD")
        
        this.getReports("mounth")
    },
    watch:{
        user:function(){
            this.getReports("mounth")
        },
        userId:function(){
            this.getReports(this.setDate)
            this.setId=0
        },
        setDate:function(oldVal,newVal){
            this.oldDateVal=oldVal
            this.newDateVal=newVal
        },
        setId:function(){
            this.changeChart()
        },
        subSetId:function(){
            this.changeChart()
        },
        reports:{
            handler(){
                this.createdChart()
                this.changeChart()
            },
            deep:true
        },
        reportLoading:function(){
            if(this.reportLoading==true){
                 
            }
            
        },
        activeTab:function(){
            console.log("activetabchange")
            if(this.activeTab=="activity"){
                this.selectDate=this.$moment().format("YYYY-MM-DD")
                this.getReports("mounth")
            }
        }
    },
}
</script>
<style scoped>
    .tab-content>.tab-pane {
        display: block;
        height: 0;
        overflow: hidden;
    }
    .tab-content>.tab-pane.active {
        height: auto;
    }
    .selectUser{
        background-color: white;
        border: 1px solid #3767a0;
        color: black;
    }
    .dateOkeyButton{
        background-color: #3767a0;
        border: 1px solid #3767a0;
        color: white;
    }
    .dateCancelButton{
        background-color: #e41749;
        border: 1px solid #e41749;
        color: white;
    }
    .activityFilterMenu button{
        color: #6a6b75;
        background-color: transparent;
    }
    .activityFilterMenu button.active{
        background-color: #3767a0;
        color: white;
    }
    .mainPanel{
        display: flex;
        border: 2px solid ;
        border-radius: 20px;
    }
    .mainPanel div:first-child{
        border-right:  2px solid;
    }
    .iptal:before{
        color:red
    }
    .ctk-date-time-picker{
        margin: unset!important;
    }   
    .card-header{
        color:white;
    }
    .border-warning{
        border-color:#fd7e14!important;
    }
    .bg-warning{
        background-color: #fd7e14!important;
    }
    .bg-light-warning{
        background-color: rgba(242, 129, 0, 0.05);
    }
    .bg-light-success{
        background-color: rgba(57, 181, 74, 0.05);
    }
    .bg-light-danger{
        background-color: rgba(239, 66, 72, 0.05);
    }
    .bg-light-primary{
        background-color:  rgba(32, 179, 249, 0.05);
    }
    .searchTitle{
    font-size: 16px;
    padding: 10px;
    color: #6a6b75;;
  }
  .underline{
    border-bottom: 1px solid rgba(0, 0, 0, .125) ;
  }
  @media screen and (min-width: 1366px) {
    .searchTitle{
      font-size:21px;
    }
}
</style>